import React from "react";
import { Box } from "@mui/material";
import "./TargetTemplate.scss";
import { createTheme, ThemeProvider, Container } from "@mui/material";
import Link from "@mui/material/Link";
import providerDirectory from "../../images/provider-directory.png";
import formulary from "../../images/formulary.png";
import sandBoxUrl from "../../images/sandbox-icon.png";
import productionUrl from "../../images/production-icon.png";
import CallMadeOutlinedIcon from "@mui/icons-material/CallMadeOutlined";
import Grid from "@mui/material/Unstable_Grid2";
import { useNavigate } from "react-router-dom";

const theme = createTheme({
    breakpoints: {
        values: {
            xs: 0,
            sm: 576,
            md: 768,
            lg: 992,
            xl: 1620,
        },
    },
});

const TargetTemplate: React.FC = () => {
    const navigate = useNavigate();

    return (
        <>
            <section className="getstart-section" id="target-getstarted">
                <ThemeProvider theme={theme}>
                    <Container maxWidth="xl">
                        <div className="title-main">
                            <small className="purple">IT’S FREE</small>
                            <h2 className="title-xl">Let’s Get Started</h2>
                        </div>

                        <div className="getstarted-box">
                            <Grid container>
                                <Grid
                                    lg={3}
                                    xs={12}
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        pr: { xl: 8, lg: 6 },
                                    }}
                                >
                                    <div className="get-start-content">
                                        <p>
                                            As per regulations, Provider Directory APIs are provided
                                            without authentication requirements. After confirming
                                            connectivity with the sandbox, utilize the details below
                                            to connect to our Production APIs:
                                        </p>
                                        <p>
                                            The URL for our Provider Directory Production endpoints
                                            follows this format, where APINAME is substituted with
                                            the API name you intend to call.
                                        </p>
                                    </div>
                                </Grid>
                                <Grid lg={9} xs={12}>
                                    <div className="box-main">
                                        <Box component="section" className="box-purple">
                                            <div className="box-header">
                                                <div className="box-header-left">
                                                    <h4 className="title-lg">Provider Directory</h4>
                                                    <p>
                                                        Resources related to providers encompass details
                                                        about insurance plans, locations, healthcare
                                                        services, and networks essential for disseminating
                                                        provider directory information. This information
                                                        also encompasses details about pharmacies.
                                                    </p>
                                                </div>
                                                <span>
                                                    <img
                                                        src={providerDirectory}
                                                        alt="Provider Directory"
                                                    />
                                                </span>
                                            </div>
                                            <div className="box-content">
                                                <Grid container spacing={4}>
                                                    <Grid lg={6} xs={12}>
                                                        <Link
                                                            className="box-link"
                                                            onClick={() =>
                                                                navigate(
                                                                    "/providerdirectory/location-api/location"
                                                                )
                                                            }
                                                        >
                                                            <div className="box-link-left">
                                                                <span>
                                                                    <img src={sandBoxUrl} alt="Sandbox URL" />
                                                                </span>
                                                                <div>
                                                                    <h5 className="title-sm">Sandbox URL</h5>
                                                                    <p>
                                                                        https://api-sandbox.aaneelconnect.com/cms/r4/providerdirectory
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div className="box-link-right">
                                                                <Link sx={{ border: "none !important" }}>
                                                                    <span>
                                                                        <>
                                                                            {" "}
                                                                            <CallMadeOutlinedIcon />
                                                                        </>
                                                                    </span>
                                                                </Link>
                                                            </div>
                                                        </Link>
                                                    </Grid>
                                                    <Grid lg={6} xs={12}>
                                                        <Link
                                                            className="box-link"
                                                            onClick={() =>
                                                                navigate(
                                                                    "/providerdirectory/location-api/location/prod"
                                                                )
                                                            }
                                                        >
                                                            <div className="box-link-left">
                                                                <span>
                                                                    <img
                                                                        src={productionUrl}
                                                                        alt="Production URL"
                                                                    />
                                                                </span>
                                                                <div>
                                                                    <h5 className="title-sm">Production URL</h5>
                                                                    <p>
                                                                        https://api.aaneelconnect.com/cms/r4/providerdirectory
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div className="box-link-right">
                                                                <Link sx={{ border: "none !important" }}>
                                                                    <span>
                                                                        <>
                                                                            {" "}
                                                                            <CallMadeOutlinedIcon />
                                                                        </>
                                                                    </span>
                                                                </Link>
                                                            </div>
                                                        </Link>
                                                    </Grid>
                                                </Grid>
                                            </div>
                                        </Box>
                                        <Box component="section" className="box-blue">
                                            <div className="box-header">
                                                <div className="box-header-left">
                                                    <h4 className="title-lg">Formulary</h4>
                                                    <p>
                                                        The two resources within this category have the
                                                        capability to furnish comprehensive payer
                                                        formulary details. Utilizing the Who Am I endpoint
                                                        for coverage information enables the retrieval of
                                                        specific member plan formulary details.
                                                    </p>
                                                </div>
                                                <span>
                                                    <img src={formulary} alt="Formulary" />
                                                </span>
                                            </div>
                                            <div className="box-content">
                                                <Grid container spacing={4}>
                                                    <Grid lg={6} xs={12}>
                                                        <Link
                                                            className="box-link"
                                                            onClick={() =>
                                                                navigate("/formulary/list-api/list")
                                                            }
                                                        >
                                                            <div className="box-link-left">
                                                                <span>
                                                                    <img src={sandBoxUrl} alt="Sandbox URL" />
                                                                </span>
                                                                <div>
                                                                    <h5 className="title-sm">Sandbox URL</h5>
                                                                    <p>
                                                                        https://api-sandbox.aaneelconnect.com/cms/r4/formulary
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div className="box-link-right">
                                                                <Link sx={{ border: "none !important" }}>
                                                                    <span>
                                                                        <>
                                                                            <CallMadeOutlinedIcon />
                                                                        </>
                                                                    </span>
                                                                </Link>
                                                            </div>
                                                        </Link>
                                                    </Grid>
                                                    <Grid lg={6} xs={12}>
                                                        <Link
                                                            className="box-link"
                                                            onClick={() =>
                                                                navigate("/formulary/list-api/list/prod")
                                                            }
                                                        >
                                                            <div className="box-link-left">
                                                                <span>
                                                                    <img
                                                                        src={productionUrl}
                                                                        alt="Production URL"
                                                                    />
                                                                </span>
                                                                <div>
                                                                    <h5 className="title-sm">Production URL</h5>
                                                                    <p>
                                                                        https://api.aaneelconnect.com/cms/r4/formulary
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div className="box-link-right">
                                                                <Link sx={{ border: "none !important" }}>
                                                                    <span>
                                                                        <>
                                                                            <CallMadeOutlinedIcon />
                                                                        </>
                                                                    </span>
                                                                </Link>
                                                            </div>
                                                        </Link>
                                                    </Grid>
                                                </Grid>
                                            </div>
                                        </Box>
                                    </div>
                                </Grid>
                            </Grid>
                        </div>
                    </Container>
                </ThemeProvider>
            </section>
        </>
    );
};

export default TargetTemplate;
